import { render } from "./ActivateType.vue?vue&type=template&id=4496b014&scoped=true"
import script from "./ActivateType.vue?vue&type=script&lang=ts"
export * from "./ActivateType.vue?vue&type=script&lang=ts"

import "./ActivateType.vue?vue&type=style&index=0&id=4496b014&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4496b014"

export default script